import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IListMyOrdersResult,
  IListMyOrdersInput,
  IListActiveOneTimeUseProductsResult,
  IListActiveOneTimeUseProductsInput,
} from '@shared/models/orders';

export const PAYMENTS_ORDER_FRAGMENT = gql`
  fragment PaymentsOrderFragment on PaymentsOrder {
    id
    insertedAt
    status

    oneTimePayment {
      id
      amount
      totalAmount
      product {
        id
        name
        # metadata {
        #   __typename
        #   ... on PaymentsProductMetadataCredits {
        #     value {
        #       export
        #       skipTrace
        #     }
        #   }
        # }
      }
    }

    metadata {
      __typename
      ... on PaymentsOrderMetadataCredits {
        value {
          export
          skipTrace
        }
      }
      ... on PaymentsOrderMetadataOpenTitle {
        value {
          externalPropertyUserListingId
        }
      }
    }
  }
`;

export const LIST_MY_ORDERS: TypedDocumentNode<
  IListMyOrdersResult,
  IListMyOrdersInput
> = gql`
  ${PAYMENTS_ORDER_FRAGMENT}
  query listMyOrders($sort: [PaymentsOrderSortInput]) {
    listMyOrders(sort: $sort) {
      count
      results {
        ...PaymentsOrderFragment
      }
    }
  }
`;

export const LIST_ACTIVE_ONE_TIME_USE_PRODUCTS: TypedDocumentNode<
  IListActiveOneTimeUseProductsResult,
  IListActiveOneTimeUseProductsInput
> = gql`
  query listActiveOneTimeUseProducts($sort: [PaymentsProductSortInput]) {
    listActiveOneTimeUseProducts(sort: $sort) {
      id
    }
  }
`;
